import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ROLE_OPTIONS, SORT_OPTIONS, SORT_TYPES } from '../../constant';
import './style.scss';

function FilterBar({
  search = '',
  onSearchChange,
  role = '',
  onRoleChange,
  sort = SORT_TYPES.JOIN_DESC,
  onSortChange,
}) {
  return (
    <div className="members-filter-bar">
      {/* SEARCH INPUT */}
      <div className="search-wrap">
        <svg
          className="search-icon"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          id="member-search"
          type="text"
          className="search-input"
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
        />
      </div>

      {/* PERMISSION FILTER */}
      <select
        id="filter-perm"
        className="filter-select"
        value={role}
        onChange={(e) => onRoleChange && onRoleChange(e.target.value)}
      >
        {ROLE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {/* SORT FILTER */}
      <select
        id="filter-sort"
        className="filter-select filter-sort"
        value={sort}
        onChange={(e) => onSortChange && onSortChange(e.target.value)}
      >
        {SORT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

FilterBar.propTypes = {
  search: PropTypes.string,
  onSearchChange: PropTypes.func,
  role: PropTypes.string,
  onRoleChange: PropTypes.func,
  sort: PropTypes.string,
  onSortChange: PropTypes.func,
};

export default memo(FilterBar);
